import doc                           from '@widesk-core/decorators/doc';
import AbstractEventDisplayModeModel from './AbstractEventDisplayModeModel';

@doc.urnResource('event_display_mode')
export default class EventDisplayModeModel extends AbstractEventDisplayModeModel {}
